var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.phaseTwoUsers.length && _vm.licenseStates.length ? _c('div', [_vm._m(0), _vm._l(_vm.phaseTwoUsers, function (phaseTwoUser) {
    return _c('div', {
      key: phaseTwoUser.id
    }, [_c('div', {
      class: _vm.$style.phaseTwoLicenseFormContainer
    }, [_c('div', {
      class: _vm.$style.phaseTwoLoNameField
    }, [_c('BaseCheckbox', {
      attrs: {
        "input-value": phaseTwoUser.id,
        "label": phaseTwoUser.name,
        "disabled": _vm.submitting
      },
      on: {
        "input": function input($event) {
          return _vm.selectLO(phaseTwoUser.id);
        }
      },
      model: {
        value: _vm.additionalLoPhaseTwoLicensesIds,
        callback: function callback($$v) {
          _vm.additionalLoPhaseTwoLicensesIds = $$v;
        },
        expression: "additionalLoPhaseTwoLicensesIds"
      }
    })], 1), _c('div', {
      class: _vm.$style.stateFields
    }, _vm._l(_vm.licenseStates, function (state) {
      return _c('div', {
        key: state.id,
        class: _vm.$style.stateField
      }, [_c('BaseCheckbox', {
        style: {
          'pointer-events': _vm.isOnlyOneStateForCheckedLO(phaseTwoUser.id) && _vm.additionalLoPhaseTwoLicenses[phaseTwoUser.id][state].active[0] ? 'none' : 'auto'
        },
        attrs: {
          "input-value": "1",
          "disabled": !_vm.additionalLoPhaseTwoLicensesIds.includes(phaseTwoUser.id) || _vm.submitting,
          "label": state
        },
        model: {
          value: _vm.additionalLoPhaseTwoLicenses[phaseTwoUser.id][state].active,
          callback: function callback($$v) {
            _vm.$set(_vm.additionalLoPhaseTwoLicenses[phaseTwoUser.id][state], "active", $$v);
          },
          expression: "additionalLoPhaseTwoLicenses[phaseTwoUser.id][state].active"
        }
      }), _c('BaseInputText', {
        staticClass: "ml-20",
        attrs: {
          "maxlength": "30",
          "disabled": !_vm.isStateActiveForLO(phaseTwoUser.id, state) || _vm.submitting,
          "name": state + ' - ',
          "placeholder": "License Number"
        },
        model: {
          value: _vm.additionalLoPhaseTwoLicenses[phaseTwoUser.id][state].number,
          callback: function callback($$v) {
            _vm.$set(_vm.additionalLoPhaseTwoLicenses[phaseTwoUser.id][state], "number", $$v);
          },
          expression: "additionalLoPhaseTwoLicenses[phaseTwoUser.id][state].number"
        }
      })], 1);
    }), 0)])]);
  })], 2) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h2', {
    staticClass: "color-primary-blue mb-5 mt-2"
  }, [_vm._v(" Please select Phase 2 LOs who should be granted the license(s) in MottoCenter. ")])]);
}]

export { render, staticRenderFns }